import moment from "moment";
import React, { useEffect, useState } from "react";
import { Table, Image } from "react-bootstrap";
import { NOTAVAILABLEIMAGE } from "../../../../../enums/GlobalEnums";

export const UserTicketsPageComponent = (props) => {
  const calcStatus = (status) => {
    if (status === 0) {
      return "New";
    } else if (status === 1) {
      return "In-Progress";
    } else if (status === 2) {
      return "Awaiting Feedback";
    } else if (status === 3) {
      return "On Hold";
    } else if (status === 4) {
      return "Re-Opened";
    } else if (status === 5) {
      return "Resolved";
    } else if (status === 6) {
      return "Closed";
    } else if (status === 7) {
      return "Archive";
    } else if (status === 8) {
      return "Called User";
    } else if (status === 9) {
      return "Completed";
    }
  };

  let filteredData = props.data;

  if (props.search) {
    filteredData = filteredData.filter((item) => {
      return (
        (item &&
          item.restaurant_id &&
          item.restaurant_id.restaurant_name &&
          item.restaurant_id.restaurant_name
            .toLowerCase()
            .includes(props.search.toLowerCase())) ||
        (item &&
          item.ticket_number &&
          item.ticket_number.includes(props.search))
      );
    });
  }

  if (props.sortBy === "Latest") {
    filteredData = filteredData?.sort(
      (a, b) => new Date(b.createdAt) - new Date(a.createdAt)
    );
  } else if (props.sortBy === "Oldest") {
    filteredData = filteredData?.sort(
      (a, b) => new Date(a.createdAt) - new Date(b.createdAt)
    );
  } else if (props.sortBy === "A-Z") {
    filteredData = filteredData?.sort((a, b) =>
      a.restaurant_id?.restaurant_name > b.restaurant_id?.restaurant_name
        ? 1
        : -1
    );
  } else if (props.sortBy === "Z-A") {
    filteredData = filteredData?.sort((a, b) =>
      b.restaurant_id?.restaurant_name > a.restaurant_id?.restaurant_name
        ? 1
        : -1
    );
  }

  if (props.filterBy) {
    if (props?.filterBy?.status >= 0)
      filteredData = filteredData?.filter(
        (ele) => ele.status == props?.filterBy?.status
      );
    if (props?.filterBy?.type)
      filteredData = filteredData?.filter(
        (ele) => ele.ticket_category_id?._id == props?.filterBy?.type
      );
  }

  // if (props.sortByDay !== 4) {
  //   filteredData = filteredData.filter((item) => {
  //     return (
  //       (props.startDay <= moment(item.createdAt).format("YYYY-MM-DD") ||
  //         props.startDay <= moment(item.updatedAt).format("YYYY-MM-DD")) &&
  //       (moment(item.createdAt).format("YYYY-MM-DD") <= props.endDay ||
  //         moment(item.updatedAt).format("YYYY-MM-DD") <= props.endDay)
  //     );
  //   });
  // }

  // if (props.startDate && props.endDate && props.clickedSearch) {
  //   let ed = new Date(props.endDate).getTime();
  //   let sd = new Date(props.startDate).getTime();

  //   filteredData = filteredData.filter((d) => {
  //     var time = new Date(d.createdAt).getTime();
  //     return sd < time && time < ed;
  //   });
  // }

  // useEffect(() => {
  //   // console.log(props.data);
  //   if (props.data) {
  //     let sortedDates = [];

  //     if (props.sortByDate === 1) {
  //       sortedDates = props.data.sort(function (a, b) {
  //         return new Date(b.updatedAt) - new Date(a.updatedAt);
  //       });
  //     } else {
  //       sortedDates = props.data.sort(function (a, b) {
  //         return new Date(a.updatedAt) - new Date(b.updatedAt);
  //       });
  //     }
  //     setTicket(sortedDates);
  //   }
  // }, [props.data, props.sortByDate]);
  return (
    <div className="col-12 p-0 user-table-reusable-superadmin table-responsive ">
      {console.log(props.search)}
      <Table className="enMinWidth900">
        <thead>
          <tr className="super_admin_all_users_table_head">
            <th style={{ width: "10%" }} className="f12-700">
              Restaurant
              <br />
              Name
            </th>
            <th style={{ width: "15%" }} className="f12-700">
              Ticket <br />
              Number
            </th>
            <th style={{ width: "15%" }} className="f12-700">
              Request
              <br />
              Number
            </th>
            <th style={{ width: "10%" }} className="f12-700">
              Issue Type
            </th>
            <th style={{ width: "10%" }} className="f12-700">
              Issue
              <br />
              Category
            </th>
            <th style={{ width: "20%" }} className="f12-700">
              Issue Description
            </th>
            <th style={{ width: "10%" }} className="f12-700">
              Status
            </th>
            <th style={{ width: "10%" }} className="f12-700">
              Ticket Date/
              <br />
              Time
            </th>
          </tr>
        </thead>
        {/* {props.allOffers.slice(start, end).map((offer, index) => ( */}
        {filteredData.map((ticket, index) => (
          <tbody className="HideShowTable" key={index}>
            <tr className="super_admin_all_users_table_body super_admin_user_view_inside_table_body">
              <td style={{ width: "10%" }}>
                <div className="d-flex flex-column align-items-start">
                  <div className="enImage45 ">
                    <Image
                      //src={require("../../../../../assets/images/UserManagement/fhr7.png")}
                      src={
                        (ticket &&
                          ticket.restaurant_id &&
                          ticket.restaurant_id.logo_url) ||
                        NOTAVAILABLEIMAGE
                      }
                      // src={
                      //   offer &&
                      //   offer.restaurant_id &&
                      //   offer.restaurant_id.logo_url
                      // }
                      alt="Restaurant logo"
                      title="Restaurant logo"
                      fluid
                    />
                  </div>
                  <div className="f11-500 text-center mt-1">
                    {ticket &&
                      ticket.restaurant_id &&
                      ticket.restaurant_id.restaurant_name}
                    {/* {offer &&
             offer.restaurant_id &&
             offer.restaurant_id.restaurant_name} */}
                  </div>
                </div>
              </td>
              <td style={{ width: "15%" }}>
                <div className="f14-500">{ticket && ticket.ticket_number}</div>
              </td>
              <td style={{ width: "15%" }}>
                <div className="f14-500">
                  {ticket && ticket.seating_request_no}
                </div>
              </td>
              <td style={{ width: "10%" }}>
                <div className="f14-500">
                  {ticket &&
                    ticket.ticket_category_id &&
                    ticket.ticket_category_id.category_name}
                </div>
              </td>
              <td style={{ width: "10%" }}>
                <div className="f14-500">
                  {ticket &&
                    ticket.ticket_sub_category_id &&
                    ticket.ticket_sub_category_id.title}
                </div>
              </td>
              <td style={{ width: "20%" }}>
                <div className="f14-400">{ticket.description}</div>
              </td>
              <td style={{ width: "10%" }}>
                <div className="f14-400 badge badge-warning p-1">
                  {calcStatus(ticket.status)}
                </div>
              </td>
              <td style={{ width: "10%" }}>
                <div className="f14-400">
                  {moment(ticket.createdAt).format("DD MMM ,YYYY")}
                  <br />
                  {moment(ticket.createdAt).format("LT")}
                </div>
              </td>
            </tr>
          </tbody>
        ))}

        {/* // ))} */}
      </Table>
    </div>
  );
};
